import { fetchFromRTM } from '../RTMResolvers';
import * as constants from './constants';

const ThemeResolver = {

  getThemeVariants: async (elementId) => {
    const message = {
      type: constants.RTM_LEARNER_SELECTED_THEME_GET,
      elementId,
    };

    const response = await fetchFromRTM(
      message,
      constants.RTM_LEARNER_SELECTED_THEME_GET_OK,
      constants.RTM_LEARNER_SELECTED_THEME_GET_ERROR,
    );

    return response;
  },

  getThemeVariant: async (themeId, variantId) => {
    const message = {
      type: constants.RTM_LEARNER_THEME_VARIANT_GET,
      themeId,
      variantId,
    };

    const response = await fetchFromRTM(
      message,
      constants.RTM_LEARNER_THEME_VARIANT_GET_OK,
      constants.RTM_LEARNER_THEME_VARIANT_GET_ERROR,
    );

    return response;
  },
};

export default ThemeResolver;
